// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// joselopez.narino@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyB422kY45gzMnwFdGA-WyTMK7nrUvhh8KA",
    authDomain: "joselopez-58fb6.firebaseapp.com",
    projectId: "joselopez-58fb6",
    storageBucket: "joselopez-58fb6.firebasestorage.app",
    messagingSenderId: "797294429766",
    appId: "1:797294429766:web:7f768f36f0a55555922c47",
    measurementId: "G-YR34DMKDCT"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)